// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./back.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.generate-serials-container {
  width: 100%;
  border-radius: 0.5rem;
  border: 1px solid var(--black1);
  margin: 1rem 0;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: 100% 0;
}
.generate-serials-container.is-variant {
  background: var(--white);
}
.generate-serials-container.is-variant input {
  background-color: var(--black1) !important;
}
.generate-serials-text {
  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;
  color: var(--black5);
  white-space: break-spaces;
  margin-top: 0.5rem;
}
.generate-serials-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: flex-start;
  white-space: nowrap;
  color: var(--black9);
  font-size: 0.9rem;
  font-weight: 500;
  padding: 1rem;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  flex-direction: column;
}
.generate-serials-header > span {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.generate-serials-header.open {
  border-bottom-color: var(--black1);
}
.generate-serials-header .switcher-container {
  width: auto;
}
.generate-serials-body {
  width: 100%;
  padding: 1rem;
}`, "",{"version":3,"sources":["webpack://./client/entrypoints/dashboard/screens/products/product/screens/components/generate-serials/index.scss"],"names":[],"mappings":"AAEE;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,cAAA;EACA,mDAAA;EACA,4BAAA;EACA,2BAAA;AADJ;AAGI;EACE,wBAAA;AADN;AAGM;EACE,0CAAA;AADR;AAME;EACE,oBAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,oBAAA;EACA,yBAAA;EACA,kBAAA;AAJJ;AAOE;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,oCAAA;EACA,eAAA;EACA,sBAAA;AALJ;AAOI;EACE,aAAA;EACA,WAAA;EACA,8BAAA;EACA,mBAAA;AALN;AAQI;EACE,kCAAA;AANN;AASI;EACE,WAAA;AAPN;AAWE;EACE,WAAA;EACA,aAAA;AATJ","sourcesContent":[".generate-serials {\n\n  &-container {\n    width: 100%;\n    border-radius: 0.5rem;\n    border: 1px solid var(--black1);\n    margin: 1rem 0;\n    background: url(\"./back.svg\");\n    background-repeat: no-repeat;\n    background-position: 100% 0;\n\n    &.is-variant {\n      background: var(--white);\n\n      input {\n        background-color: var(--black1) !important;\n      }\n    }\n  }\n\n  &-text {\n    font-family: 'Inter';\n    font-style: normal;\n    font-weight: 400;\n    font-size: 12px;\n    line-height: 15px;\n    color: var(--black5);\n    white-space: break-spaces;\n    margin-top: 0.5rem;\n  }\n\n  &-header {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n    align-items: flex-start;\n    white-space: nowrap;\n    color: var(--black9);\n    font-size: .9rem;\n    font-weight: 500;\n    padding: 1rem;\n    border-bottom: 1px solid transparent;\n    cursor: pointer;\n    flex-direction: column;\n\n    & > span {\n      display: flex;\n      width: 100%;\n      justify-content: space-between;\n      align-items: center;\n    }\n\n    &.open {\n      border-bottom-color: var(--black1);\n    }\n\n    .switcher-container {\n      width: auto;\n    }\n  }\n\n  &-body {\n    width: 100%;\n    padding: 1rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
